// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HomeKindofTrip-container-N3Aui {
  max-width: 1274px;
  margin: 0 auto;
}

.HomeKindofTrip-homeFindBg-n9I08 {
  width: 100%;
  height: 100%;
  background-position: top center;
  background-size: cover;
  position: absolute;
  left: 0px;
  right: 0px;
  top: 0px;
  border-radius: 15px;
}

.HomeKindofTrip-bgCss-a0her {
  background-color: #282828b3;
  color: var(--white-text);
  border-radius: 6px;
  padding: 20px;
  word-break: break-word;
}

.HomeKindofTrip-homeFind-nUU_5 {
  padding: 60px 0px;
}

.HomeKindofTrip-borderBottom-mtqpo {
  position: relative;
}

.HomeKindofTrip-borderBottom-mtqpo::after {
  content: '';
  width: 55px;
  height: 4px;
  background: var(--common-link-color);
  position: absolute;
  bottom: 13px;
  left: 0;
}

.HomeKindofTrip-bgSection-b_qec {
  position: relative;
  height: auto;
  min-height: 520px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: end;
      -ms-flex-align: end;
          align-items: flex-end;
}

.HomeKindofTrip-bgInnerSection-eC1dd {
  position: relative;
}

@media screen and (max-width: 1200px) {
  .HomeKindofTrip-borderBottom-mtqpo::after {
    display: none;
  }

  .HomeKindofTrip-homeFind-nUU_5 {
    padding: 60px 25px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Home/HomeKindofTrip/HomeKindofTrip.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,sBAAsB;EACtB,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,WAAW;EACX,oCAAoC;EACpC,kBAAkB;EAClB,YAAY;EACZ,OAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,sBAAqB;MAArB,mBAAqB;UAArB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".container {\n  max-width: 1274px;\n  margin: 0 auto;\n}\n\n.homeFindBg {\n  width: 100%;\n  height: 100%;\n  background-position: top center;\n  background-size: cover;\n  position: absolute;\n  left: 0px;\n  right: 0px;\n  top: 0px;\n  border-radius: 15px;\n}\n\n.bgCss {\n  background-color: #282828b3;\n  color: var(--white-text);\n  border-radius: 6px;\n  padding: 20px;\n  word-break: break-word;\n}\n\n.homeFind {\n  padding: 60px 0px;\n}\n\n.borderBottom {\n  position: relative;\n}\n\n.borderBottom::after {\n  content: '';\n  width: 55px;\n  height: 4px;\n  background: var(--common-link-color);\n  position: absolute;\n  bottom: 13px;\n  left: 0;\n}\n\n.bgSection {\n  position: relative;\n  height: auto;\n  min-height: 520px;\n  display: flex;\n  align-items: flex-end;\n}\n\n.bgInnerSection {\n  position: relative;\n}\n\n@media screen and (max-width: 1200px) {\n  .borderBottom::after {\n    display: none;\n  }\n\n  .homeFind {\n    padding: 60px 25px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `HomeKindofTrip-container-N3Aui`,
	"homeFindBg": `HomeKindofTrip-homeFindBg-n9I08`,
	"bgCss": `HomeKindofTrip-bgCss-a0her`,
	"homeFind": `HomeKindofTrip-homeFind-nUU_5`,
	"borderBottom": `HomeKindofTrip-borderBottom-mtqpo`,
	"bgSection": `HomeKindofTrip-bgSection-b_qec`,
	"bgInnerSection": `HomeKindofTrip-bgInnerSection-eC1dd`
};
module.exports = ___CSS_LOADER_EXPORT___;
